import * as React from "react";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { AccountRoleActorCategory } from "../../../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { AccountRoleByActorDetails } from "../../../../../../../Wrap/Models/Domains/Account/AccountRoleByActorDetails";
import { SubAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";
import { TrustDetail } from "../../../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { AccountRoleWithAccountDetails } from "../../../../../../../Wrap/Models/Domains/Customers/AccountRoleWithAccountDetails";
import { Organisation } from "../../../../../../../Wrap/Models/Models/Customer/Organisation";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { UserStore } from "../../../../../Stroes/Variable";
import { AccountInfoAction } from "./Action/AccountInfoAction";
import { TrustTable } from "./Components/TrustTable";
import { ClientRecordAction } from "../../../ClientRecord/Action/ClientRecordAction";
import { ClientRecordTab, roleTypeMap } from "../../../ClientRecord/Resource/Contents";
import { ClientRecordStore } from "../../../ClientRecord/Store/Variable";
import { PortfolioDashboardAction } from "../../Action/PortfolioDashboardAction";
import { PortfolioDashboardAccountRolesStore, PortfolioDashboardStore } from "../../Store/Variable";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import { PresentationViewButton } from "../Common/PresentationViewButton";
import { PresentationContext } from "../Common/PresentationViewWrapper";
import { InterestedParties } from "./Components/InterestedParties";
import { PortfolioClientRoleDiagram } from "./Components/PortfolioClientRoleDiagram";
import { RoleStatus } from "../../../../../../../Wrap/Constants/Enums/RoleStatus";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../../../Wrap/Constants/Enums/ContextType";
import { PermissionAction } from "../../../../../../Shared/Permission/Action/PermissionAction";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { Urls } from "../../../../../Urls";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import {
    consolidatedAccountDashboardTabEnum,
    dashboardRelatedPageEnum,
    portfolioDashboardTabEnum,
    prospectDashboardTabEnum,
} from "../../Resource/Content";

interface IPortfolioDashboardRolesState {
    accountRoleDetails: AccountRoleWithAccountDetails;
    roleDiagramConfig: any;
    trustDetail: TrustDetail;
    isLoading: boolean;
    trustAccountHolder: Organisation;
    slideNumber: number;
    userInfo: User;
    canAccessNewUserPage: boolean;
}

interface IPortfolioDashboardRolesProps extends IPortfolioDashboardComponentProps {
    customerType: CustomerType;
}

export class PortfolioDashboardRoles extends PortfolioDashboardComponent<
    IPortfolioDashboardRolesProps,
    IPortfolioDashboardRolesState
> {
    constructor(props: IPortfolioDashboardRolesProps) {
        super(props);
        this.initState();
        this.subscribeToStore(PortfolioDashboardAccountRolesStore, () => this.onStoreChange());
    }

    initState() {
        this.state = {
            accountRoleDetails: null,
            roleDiagramConfig: null,
            trustDetail: null,
            isLoading: false,
            trustAccountHolder: null,
            slideNumber: 0,
            userInfo: UserStore.getUserInfo(),
            canAccessNewUserPage: false,
        };
    }

    getData(selectedSubAccountHierarchyIds: string[]) {}

    private getNewUserPermission() {
        PermissionAction.getPermissionForASPXPage("/Admin/Users/NewUser.aspx", (res) => {
            this.setState({ canAccessNewUserPage: res.HasPermission });
        });
    }
    private onStoreChange() {
        this.getRoleDiagram();
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {
        this.getNewUserPermission();
        this.setState({ isLoading: true });
        PortfolioDashboardAction.getAccountRoleWithAccountDetails(this.props.customerid);
        const indexIsBtnPresentationClicked = Object.keys(portfolioDashboardTabEnum).indexOf(
            portfolioDashboardTabEnum.Roles
        );
        if (this.props.isBtnPresentationClicked[indexIsBtnPresentationClicked]) {
            this.props.onPresentationViewStatusChange(
                portfolioDashboardTabEnum.Roles,
                this.props.isBtnPresentationClicked
            );
        } else {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                HierarchyLevelName.Customer,
                                this.props.customerid
                            ),
                        })
                        .roles.getUrl(),
                    pageTitle: `${document.title} - client - roles`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }
    }

    private getRoleDiagram() {
        const result = PortfolioDashboardAccountRolesStore.getData();
        const activeAccountRoles = result.AccountRoles.filter(
            (x) =>
                x.AccountRoleStatus == RoleStatus.Active &&
                x.AccountRoleType != RoleType.LifeAssured &&
                x.AccountStatus.toLowerCase() != "inprogress"
        );
        result.AccountRoles = activeAccountRoles;
        this.setState({ accountRoleDetails: result });
        if (
            (result && CommonHelper.isNullOrEmpty(result?.AccountRoles)) ||
            CommonHelper.isNullOrEmpty(activeAccountRoles)
        ) {
            this.setState({ isLoading: false });
        } else if (
            this.props.customerType == CustomerType.Company ||
            this.props.customerType == CustomerType.CorporateTrust ||
            this.props.customerType == CustomerType.Trust
        ) {
            ClientRecordAction.getTrustDetails(this.getHierarchyId(result.AccountRoles[0].AccountId), (detail) => {
                this.setState({ trustDetail: detail });
                this.getOrganisationRoleDiagramConfifg(result);
                this.getOrganisationData();
            });
        } else {
            this.getIndividualRoleDiagramConfig(result);
        }
    }

    private getOrganisationData() {
        const allAccounts = PortfolioDashboardStore.getData();
        if (allAccounts && allAccounts.length > 0) {
            AccountInfoAction.getOrganisationDetail(
                this.props.customerid,
                allAccounts[0].HierarchyId,
                (organisation) => {
                    this.setState({ trustAccountHolder: organisation, isLoading: false });
                }
            );
        } else {
            this.setState({ isLoading: false });
        }
    }

    private getOrganisationRoleDiagramConfifg(accountRoleDetails: AccountRoleWithAccountDetails) {
        const data = ClientRecordStore.getData();
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.OrganisationDetails])) {
            const organisation: Organisation = data[ClientRecordTab.OrganisationDetails];
            const roleDiagramConfig = {
                subject: organisation.Name,
                id: this.props.customerid,
                isTrustEntity: true,
                url: "",
                holdings: this.getHoldingsConfig(
                    accountRoleDetails.AccountRoles,
                    accountRoleDetails.SubAccountInfos,
                    organisation.CustomerType,
                    organisation.Name,
                    true
                ),
            };
            this.setState({ roleDiagramConfig: roleDiagramConfig });
        }
    }

    private getIndividualRoleDiagramConfig(accountRoleDetails: AccountRoleWithAccountDetails) {
        if (accountRoleDetails?.AccountRoles && accountRoleDetails?.AccountRoles.length > 0) {
            const name =
                accountRoleDetails.PersonalDetails.GivenName + " " + accountRoleDetails.PersonalDetails.FamilyName;
            const roleDiagramConfig = {
                subject: name,
                id: this.props.customerid,
                isTrustEntity: false,
                url: "",
                holdings: this.getHoldingsConfig(
                    accountRoleDetails.AccountRoles,
                    accountRoleDetails.SubAccountInfos,
                    CustomerType.Individual,
                    name,
                    false
                ),
            };
            this.setState({ roleDiagramConfig: roleDiagramConfig, isLoading: false });
        }
    }

    private getHoldingsConfig(
        accountRoles: Array<AccountRoleByActorDetails>,
        subAccounts: Array<SubAccount>,
        customerType: CustomerType,
        clientName: string,
        isTrustAccountHolder: boolean
    ) {
        const holdings = [];
        accountRoles.forEach((role) => {
            const detail = this.state.trustDetail;
            holdings.push({
                type: roleTypeMap[role.AccountRoleType],
                roleTypeId: role.AccountRoleType,
                accountName: role.AccountName,
                id: role.ClAccountId,
                hierarchyId: this.getHierarchyId(role.AccountId),
                isTrustAccount: isTrustAccountHolder,
                products: this.getProductsConfig(
                    role.ClAccountId,
                    subAccounts,
                    this.displayWrapCashSubAccount(role, detail, customerType)
                ),
                customerName:
                    role.AccountRoleType == RoleType.JointAccountHolder ? role.OtherJointHolderName : clientName,
                otherCustomerId: role.OtherJointHolderCustomerId,
            });
        });
        return holdings;
    }

    private displayWrapCashSubAccount(
        accountRole: AccountRoleByActorDetails,
        trustDetail: TrustDetail,
        customerType: CustomerType
    ) {
        if (customerType == CustomerType.Individual || customerType == CustomerType.CorporateTrust) {
            return true;
        }
        if (trustDetail?.NewOrExistingTrust == "EXISTING") {
            return true;
        }
        if (trustDetail?.NewOrExistingTrust == "NEW" && trustDetail?.TrustType == "GIFTPLAN") {
            return true;
        }

        return false;
    }

    private getHierarchyId(accountId: number) {
        return HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Account, accountId);
    }

    private getProductsConfig(headClAccountId: string, allSubAccounts: Array<SubAccount>, displayWrapCash: boolean) {
        const products = [];
        const subAccounts = allSubAccounts.filter(
            (subAccount) => subAccount.ClAccountId.split("-")[0] == headClAccountId
        );
        subAccounts.sort((a, b) => a.ClAccountId.localeCompare(b.ClAccountId));
        if (subAccounts && subAccounts.length > 0)
            {subAccounts.push(
                subAccounts.splice(
                    subAccounts.indexOf(subAccounts.filter((a) => a.SubAccountType == SubAccountType.WrapCash)[0]),
                    1
                )[0]
            );}
        subAccounts.forEach((subAccount) => {
            if (subAccount.SubAccountType != SubAccountType.WrapCash || displayWrapCash == true) {
                products.push({
                    name: subAccount.ProductDisplayName,
                    id: subAccount.ClAccountId,
                    hierarchyid: subAccount.HierarchyId,
                    type: subAccount?.SubAccountType,
                });
            }
        });
        return products;
    }

    private handleLaunchpadClick() {
        const context: Record<string, string> = {};

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {context.customerId = customerHierarchyId;}

        (window as any).AppStore.open(context);
    }

    public render(): JSX.Element {
        const allAccounts = PortfolioDashboardStore.getData();
        const { trustAccountHolder, trustDetail, isLoading, accountRoleDetails } = this.state;
        const { isPresentationView } = this.context;
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }

        const isAppStoreEnabled = this.state.userInfo?.IsAppStoreEnabledForUser;
        const result = PortfolioDashboardAccountRolesStore.getData();
        if (this.state.roleDiagramConfig != null) {
            const distinctAccountIds = [...new Set(accountRoleDetails.AccountRoles.map((x) => x.AccountId))];
            const hierarchyIds = distinctAccountIds.map((x) =>
                HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Account, x)
            );
            return (
                <div role={isPresentationView ? "main" : "tabpanel"} id="panel-6" tabIndex={0} aria-labelledby="tab-6">
                    <div className="panel-subtle">
                        <div className="col-right">
                            <PresentationViewButton
                                onClick={() => {
                                    this.addEvent({
                                        event: "roletab_interaction",
                                        eventParameters: {
                                            eventCategory: eventCategoryForGTM.documentTab,
                                            eventAction: "interactions",
                                            eventLabel: "presentation mode",
                                        },
                                    });
                                    this.props.onPresentationViewStatusChange(
                                        portfolioDashboardTabEnum.Roles,
                                        this.props.isBtnPresentationClicked
                                    );
                                }}
                            />
                            {isAppStoreEnabled && (
                                <button
                                    type="button"
                                    className="applications-pad-button"
                                    onClick={this.handleLaunchpadClick.bind(this)}
                                >
                                    <span className="sr-only">Applications pad</span>
                                    <span className="icon" aria-hidden="true"></span>
                                </button>
                            )}
                        </div>
                        <PortfolioClientRoleDiagram roleDiagramConfig={this.state.roleDiagramConfig} />
                        {(this.props.customerType == CustomerType.CorporateTrust ||
                            this.props.customerType == CustomerType.Trust) && (
                            <TrustTable
                                data={trustAccountHolder?.OrganisationMembers.filter(
                                    (x) =>
                                        x?.Individual?.ActorCategory == AccountRoleActorCategory.Customer ||
                                        x?.Relationships.includes(RelationshipType.CorporateTrustee)
                                )}
                                headAccountHierarchyId={
                                    allAccounts[0] != null
                                        ? allAccounts[0]?.HierarchyId
                                        : ContextStore.getUrlParamsHierarchyId(ContextType.Customer)
                                }
                                trustEntityCustomerId={this.props.customerid}
                                clAccountId={trustDetail?.ClAccountId}
                                trustCategory={trustDetail?.TrustCategory}
                                hasReadWriteAccessToAdviser={this.props.hasReadWriteAccessToAdviser}
                                onUpdateClientAccess={() => this.getOrganisationData()}
                            />
                        )}

                        {!isPresentationView && (
                            <InterestedParties
                                clAccountId={
                                    trustDetail != null
                                        ? trustDetail.ClAccountId
                                        : accountRoleDetails?.AccountRoles?.find(
                                              (x) => x?.AccountRoleType == RoleType.Trustee
                                          )?.ClAccountId
                                }
                                hierarchyIds={hierarchyIds}
                                customerId={this.props.customerid}
                                isOrganisation={trustAccountHolder != null}
                                userIsAdviser={this.state.userInfo.IsAdviser}
                                showAddInterestedParty={
                                    accountRoleDetails?.AccountRoles?.some(
                                        (x) =>
                                            x?.AccountRoleType == RoleType.IndividualAccountHolder ||
                                            x?.AccountRoleType == RoleType.JointAccountHolder ||
                                            x?.AccountRoleType == RoleType.TrustAccountHolder
                                    ) &&
                                    (this.state.userInfo.IsAdviser != true || this.state.canAccessNewUserPage)
                                }
                                hasReadWriteAccessToAdviser={this.props.hasReadWriteAccessToAdviser}
                            />
                        )}
                    </div>
                </div>
            );
        }
        if (this.state.isLoading == false) {
            return (
                <p className="warning-message ad d1">
                    Client roles will appear here once the account set up has been completed.
                </p>
            );
        }
        return <></>;
    }
}
PortfolioDashboardRoles.contextType = PresentationContext;
